import React, { lazy, Suspense } from 'react';

const loadable = (importFunc: any, { fallback = false } = { fallback: false }) => {

    const LazyComponent = lazy(importFunc);

    return (props: any) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

export default loadable;
